export const colors = {
    'help-text-input': '#f2a100',
    'search-button': '#263238',
    'search-button-hover': '#091820',
    dark: '#146F62',
    'dark-hover': '#114E45',
    yellow: '#f2a100',
    'accent-grey': '#E1E1E1',
    grey: '#707070',
    primary: '#178A7B',
    accent: '#65ABA0',
    'accent-hover': '#4E847C',
    'delete-hover': '#AC3E3D',
    'delete-red': '#E24C4B',
    white: '#ffffff',
    red: '#BC0000',
    blue: '#006594',
    'dark-blue': '#004667',
    orange: '#EE8013',
    black: '#000000',
    'modal-grey': '#707070B3',

    inTimeColor: getComputedStyle(document.documentElement).getPropertyValue('--in-time-color').trim(),
    toleranceTimeColor: getComputedStyle(document.documentElement).getPropertyValue('--tolerance-time-color').trim(),
    afterHoursColor: getComputedStyle(document.documentElement).getPropertyValue('--after-hours-color').trim(),
    absenceColor: getComputedStyle(document.documentElement).getPropertyValue('--absence-color').trim(),
    transparent: getComputedStyle(document.documentElement).getPropertyValue('--transparent').trim(),

    general00Opacity66: getComputedStyle(document.documentElement).getPropertyValue('--general-00-opacity66').trim(),
    general950Opacity10: getComputedStyle(document.documentElement).getPropertyValue('--general-950-opacity10').trim(),

    secondary25: getComputedStyle(document.documentElement).getPropertyValue('--secondary-25').trim(),
    secondary35: getComputedStyle(document.documentElement).getPropertyValue('--secondary-35').trim(),
    secondary45: getComputedStyle(document.documentElement).getPropertyValue('--secondary-45').trim(),
    secondary50: getComputedStyle(document.documentElement).getPropertyValue('--secondary-50').trim(),
    secondary100: getComputedStyle(document.documentElement).getPropertyValue('--secondary-100').trim(),
    secondary150: getComputedStyle(document.documentElement).getPropertyValue('--secondary-150').trim(),
    secondary200: getComputedStyle(document.documentElement).getPropertyValue('--secondary-200').trim(),
    secondary400: getComputedStyle(document.documentElement).getPropertyValue('--secondary-400').trim(),
    secondary500: getComputedStyle(document.documentElement).getPropertyValue('--secondary-500').trim(),
    secondary600: getComputedStyle(document.documentElement).getPropertyValue('--secondary-600').trim(),
    secondary700: getComputedStyle(document.documentElement).getPropertyValue('--secondary-700').trim(),
    secondary800: getComputedStyle(document.documentElement).getPropertyValue('--secondary-800').trim(),
    secondary950: getComputedStyle(document.documentElement).getPropertyValue('--secondary-950').trim(),

    success50: getComputedStyle(document.documentElement).getPropertyValue('--success-50').trim(),
    success100: getComputedStyle(document.documentElement).getPropertyValue('--success-100').trim(),
    success150: getComputedStyle(document.documentElement).getPropertyValue('--success-150').trim(),
    success200: getComputedStyle(document.documentElement).getPropertyValue('--success-200').trim(),
    success300: getComputedStyle(document.documentElement).getPropertyValue('--success-300').trim(),
    success400: getComputedStyle(document.documentElement).getPropertyValue('--success-400').trim(),
    success500: getComputedStyle(document.documentElement).getPropertyValue('--success-500').trim(),
    success600: getComputedStyle(document.documentElement).getPropertyValue('--success-600').trim(),
    success650: getComputedStyle(document.documentElement).getPropertyValue('--success-650').trim(),
    success700: getComputedStyle(document.documentElement).getPropertyValue('--success-700').trim(),

    warning50: getComputedStyle(document.documentElement).getPropertyValue('--warning-50').trim(),
    warning100: getComputedStyle(document.documentElement).getPropertyValue('--warning-100').trim(),
    warning150: getComputedStyle(document.documentElement).getPropertyValue('--warning-150').trim(),
    warning200: getComputedStyle(document.documentElement).getPropertyValue('--warning-200').trim(),
    warning300: getComputedStyle(document.documentElement).getPropertyValue('--warning-300').trim(),
    warning400: getComputedStyle(document.documentElement).getPropertyValue('--warning-400').trim(),
    warning500: getComputedStyle(document.documentElement).getPropertyValue('--warning-500').trim(),
    warning600: getComputedStyle(document.documentElement).getPropertyValue('--warning-600').trim(),
    warning700: getComputedStyle(document.documentElement).getPropertyValue('--warning-700').trim(),

    errorCode50: getComputedStyle(document.documentElement).getPropertyValue('--error-code-50').trim(),
    errorCode100: getComputedStyle(document.documentElement).getPropertyValue('--error-code-100').trim(),
    errorCode150: getComputedStyle(document.documentElement).getPropertyValue('--error-code-150').trim(),
    errorCode200: getComputedStyle(document.documentElement).getPropertyValue('--error-code-200').trim(),
    errorCode300: getComputedStyle(document.documentElement).getPropertyValue('--error-code-300').trim(),
    errorCode400: getComputedStyle(document.documentElement).getPropertyValue('--error-code-400').trim(),
    errorCode500: getComputedStyle(document.documentElement).getPropertyValue('--error-code-500').trim(),
    errorCode600: getComputedStyle(document.documentElement).getPropertyValue('--error-code-600').trim(),
    errorCode700: getComputedStyle(document.documentElement).getPropertyValue('--error-code-700').trim(),
    errorCode800: getComputedStyle(document.documentElement).getPropertyValue('--error-code-800').trim(),
    errorCode900: getComputedStyle(document.documentElement).getPropertyValue('--error-code-900').trim(),
    errorCode950: getComputedStyle(document.documentElement).getPropertyValue('--error-code-950').trim(),

    shades50: getComputedStyle(document.documentElement).getPropertyValue('--shades-50').trim(),
    shades100: getComputedStyle(document.documentElement).getPropertyValue('--shades-100').trim(),
    shades125: getComputedStyle(document.documentElement).getPropertyValue('--shades-125').trim(),
    shades150: getComputedStyle(document.documentElement).getPropertyValue('--shades-150').trim(),
    shades200: getComputedStyle(document.documentElement).getPropertyValue('--shades-200').trim(),
    shades300: getComputedStyle(document.documentElement).getPropertyValue('--shades-300').trim(),
    shades400: getComputedStyle(document.documentElement).getPropertyValue('--shades-400').trim(),
    shades425: getComputedStyle(document.documentElement).getPropertyValue('--shades-425').trim(),
    shades500: getComputedStyle(document.documentElement).getPropertyValue('--shades-500').trim(),
    shades600: getComputedStyle(document.documentElement).getPropertyValue('--shades-600').trim(),
    shades700: getComputedStyle(document.documentElement).getPropertyValue('--shades-700').trim(),
    shades800: getComputedStyle(document.documentElement).getPropertyValue('--shades-800').trim(),
    shades900: getComputedStyle(document.documentElement).getPropertyValue('--shades-900').trim(),
    shades950: getComputedStyle(document.documentElement).getPropertyValue('--shades-950').trim(),

    background: getComputedStyle(document.documentElement).getPropertyValue('--background').trim(),
    background50: getComputedStyle(document.documentElement).getPropertyValue('--background-50').trim(),
    background200: getComputedStyle(document.documentElement).getPropertyValue('--background-200').trim(),

    green: getComputedStyle(document.documentElement).getPropertyValue('--green').trim(),

    primary20: getComputedStyle(document.documentElement).getPropertyValue('--primary-20').trim(),
    primary25: getComputedStyle(document.documentElement).getPropertyValue('--primary-25').trim(),
    primary50: getComputedStyle(document.documentElement).getPropertyValue('--primary-50').trim(),
    primary100: getComputedStyle(document.documentElement).getPropertyValue('--primary-100').trim(),
    primary200: getComputedStyle(document.documentElement).getPropertyValue('--primary-200').trim(),
    primary300: getComputedStyle(document.documentElement).getPropertyValue('--primary-300').trim(),
    primary400: getComputedStyle(document.documentElement).getPropertyValue('--primary-400').trim(),
    primary500: getComputedStyle(document.documentElement).getPropertyValue('--primary-500').trim(),
    primary600: getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim(),
    primary700: getComputedStyle(document.documentElement).getPropertyValue('--primary-700').trim(),
    primary800: getComputedStyle(document.documentElement).getPropertyValue('--primary-800').trim(),
    primary900: getComputedStyle(document.documentElement).getPropertyValue('--primary-900').trim(),
    primary950: getComputedStyle(document.documentElement).getPropertyValue('--primary-950').trim(),

    text50: getComputedStyle(document.documentElement).getPropertyValue('--text-50').trim(),
    text700: getComputedStyle(document.documentElement).getPropertyValue('--text-700').trim(),
    text950: getComputedStyle(document.documentElement).getPropertyValue('--text-950').trim(),
    general00: getComputedStyle(document.documentElement).getPropertyValue('--general-00').trim(),
    general950: getComputedStyle(document.documentElement).getPropertyValue('--general-950').trim(),

    accent50: getComputedStyle(document.documentElement).getPropertyValue('--accent-50').trim(),
    accent400: getComputedStyle(document.documentElement).getPropertyValue('--accent-400').trim(),
    accent450: getComputedStyle(document.documentElement).getPropertyValue('--accent-450').trim(),
    accent475: getComputedStyle(document.documentElement).getPropertyValue('--accent-475').trim(),
    accent550: getComputedStyle(document.documentElement).getPropertyValue('--accent-550').trim(),
    accent600: getComputedStyle(document.documentElement).getPropertyValue('--accent-600').trim(),
    accent650: getComputedStyle(document.documentElement).getPropertyValue('--accent-650').trim(),
    accent900: getComputedStyle(document.documentElement).getPropertyValue('--accent-900').trim(),
    rgbGeneral950: getComputedStyle(document.documentElement).getPropertyValue('--rgb-general-950').trim(),
    rgbPrimary900: getComputedStyle(document.documentElement).getPropertyValue('--rgb-primary-900').trim(),
};
